module.exports = __webpack_public_path__ + "img/167.05e04dc7.jpg";